import React from "react";
import Card from "./card";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import BoxImage1 from "./../../assets/homepage_1_glider_1_item_1.jpg";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const Deals = () => {
  return (
    <div className="bg-[#e6e8f0] px-5 pb-5">
      <div className="flex justify-between items-center ">
        <p className="my-4 font-rubik font-bold text-2xl">Deals of the Week</p>
      </div>

      <Carousel responsive={responsive}>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
        <div className="mr-2">
          <Card />
        </div>
      </Carousel>

      <div className="flex flex-col md:flex-row gap-2 mt-4">
        <div className="bg-white p-2 rounded-md relative">
          <div className="max-h-[250px] relative">
            <img src={BoxImage1} alt="" className="object-cover" />
            <div className="absolute top-0 flex flex-col justify-center p-2 md:p-4 h-full">
              <div className="flex flex-col justify-center gap-2 md:gap-4">
                <h1 className="text-white font-rubik font-bold text-sm md:text-xl">
                  Batman Arkham Knight
                </h1>
                <p className="text-white text-sm font-rubik max-w-[300px]">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </p>
                <button className="text-base max-w-[100px] md:max-w-[150px] font-rubik font-medium bg-primary p-1 md:p-2 rounded-full text-white">
                  Shop Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white p-2 rounded-md relative">
          <div className="max-h-[250px] relative">
            <img src={BoxImage1} alt="" className="object-cover" />
            <div className="absolute top-0 flex flex-col justify-center p-2 md:p-4 h-full">
              <div className="flex flex-col justify-center gap-2 md:gap-4">
                <h1 className="text-white font-rubik font-bold text-sm md:text-xl">
                  Batman Arkham Knight
                </h1>
                <p className="text-white text-sm font-rubik max-w-[300px]">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </p>
                <button className="text-base max-w-[100px] md:max-w-[150px] font-rubik font-medium bg-primary p-1 md:p-2 rounded-full text-white">
                  Shop Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deals;
